import type React from "react";
import {ReactFlowProvider} from "@xyflow/react";
import type {m_taxonomy} from "~/services/classes/TaxonomyClasses";
import {TaxonomyTreeCanvas} from "./TaxonomyTreeCanvas";

type TaxonomyTreeViewProps = {
    taxonomy: m_taxonomy.FullSerializer;
    /** Shown after the tree's controls above the canvas (the view switch). */
    toolbar?: React.ReactNode;
};

/** The "Tree" view of All categories: draws the taxonomy (loaded by the tab) on the canvas. */
export const TaxonomyTreeView: React.FC<TaxonomyTreeViewProps> = ({taxonomy, toolbar}) => (
    // Remount per taxonomy so the expansion, filters and viewport start fresh.
    <ReactFlowProvider key={taxonomy.id}>
        <TaxonomyTreeCanvas taxonomy={taxonomy} toolbar={toolbar}/>
    </ReactFlowProvider>
);
